import Header from "../../../../Components/Header";
import GRNForm from "./GRNForm";
import { Helmet } from "react-helmet";
const CreatePurchaseReceipt = () => {  
  return (
    <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
            <Helmet>
        <title>GRN - Create</title>
      </Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <GRNForm />
      </div>
    </div>
  );
};

export default CreatePurchaseReceipt;
